export default __webpack_public_path__ + "static/media/solicitud-vacaciones.5bd6488e.svg";